module.exports = __webpack_public_path__ + "img/pt-18.7bbb90de.jpg";